import React from "react";
import type { TypeSafeTableColumns } from "@dealer-center/core-components";
import type { vehicleInterface } from "@dealer-center/ddc-pages-vin-decode-interface";

export const columns: TypeSafeTableColumns<vehicleInterface> = [
  {
    title: "VehicleId",
    dataIndex: "vehicleId"
  },
  {
    title: "Y/M/M",
    render: record => {
      return (
        <>
          {record.year}
          <br />
          {record.make}
          <br />
          {record.model}
        </>
      );
    }
  },
  {
    title: "Model Code",
    dataIndex: "modelCode"
  },
  {
    title: "Trim",
    dataIndex: "trim"
  },
  {
    title: "Body",
    dataIndex: "bodyStyle"
  },
  {
    title: "Drs",
    dataIndex: "doors"
  },
  {
    title: "Trans",
    dataIndex: "transmission"
  },
  {
    dataIndex: "wheelbase",
    title: "Wheelbase"
  },
  {
    title: "Engine",
    render: record => {
      return (
        <>
          {record.engine}
          <br />
          {record.engineType}
          <br />
          {record.engineLiters}
        </>
      );
    }
  }
];
